<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Text</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Send Text Message
        </h1>
        <form id="smsForm" name="smsForm" @submit.prevent="sendSms">
          <h2 class="font-bold mb-4 text-center">
            To: {{ sendingToNumber }}
          </h2>
          <div class="mx-auto max-w-sm text-center flex flex-wrap justify-center">
            <div class="flex items-center mr-2 mb-4">
              <input id="borrowerPhone" v-model="smsForm.textTo" :value="[lead.phone]" type="radio" name="textToBorrower" class="rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-indigo-500 checked:border-indigo-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" checked @click="borrowerTo()" />
              <label for="borrowerPhone" class="flex items-center text-sm font-light cursor-pointer">Borrower</label>
            </div>
            <div v-if="lead.phoneCoborrower" class="flex items-center mr-2 mb-4">
              <input id="coBorrowerPhone" v-model="smsForm.textTo" :value="[lead.phoneCoborrower]" type="radio" name="coBorrowerPhone" class="rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-indigo-500 checked:border-indigo-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" @click="coBorrowerTo()" />
              <label for="coBorrowerPhone" class="flex items-center text-sm font-light cursor-pointer">Co-Borrower</label>
            </div>
            <div v-if="lead.phoneCoborrower" class="flex items-center mr-2 mb-4">
              <input id="bothTo" v-model="smsForm.textTo" :value="[lead.phone, lead.phoneCoborrower]" type="radio" name="bothTo" class="rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-indigo-500 checked:border-indigo-500 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer" @click="bothTo()" />
              <label for="bothTo" class="flex items-center text-sm font-light cursor-pointer">Both</label>
            </div>
            <div v-if="smsForm.errors.textTo" class="form-error">{{ smsForm.errors.textTo }}</div>
          </div>
          <select-input v-model="selectedInputId" class="pb-4 w-full" label="Select SMS Template" @change="onTemplateChange">
            <option v-for="smsSingle in smsTemplateOptions" :key="smsSingle.id" :value="smsSingle.id">{{ smsSingle.title }}</option>
          </select-input>
          <textarea-input id="smsTemplate" v-model="smsForm.smsTemplate" :error="smsForm.errors.smsTemplate" name="smsTemplate" rows="3" class="w-full" />
          <div id="loan_error" class="hidden form-error" />
          <div class="text-right pb-4 text-sm w-full"><span>{{ 1000 - smsForm.smsTemplate.length }} characters remaining</span></div>
          <div class="flex flex-wrap overflow-hidden">
            <div class="text-center text-m mx-auto">
              <span class="cursor-pointer" @click="insertField('😊')">😊</span>
              <span class="cursor-pointer" @click="insertField('😆')">😆</span>
              <span class="cursor-pointer" @click="insertField('🤣')">🤣</span>
              <span class="cursor-pointer" @click="insertField('😜')">😜</span>
              <span class="cursor-pointer" @click="insertField('🤔')">🤔</span>
              <span class="cursor-pointer" @click="insertField('👍')">👍</span>
              <span class="cursor-pointer" @click="insertField('🙏')">🙏</span>
              <span class="cursor-pointer" @click="insertField('🥰')">🥰</span>
              <span class="cursor-pointer" @click="insertField('❤️')">❤️</span>
              <span class="cursor-pointer" @click="insertField('🎉')">🎉</span>
              <span class="cursor-pointer" @click="insertField('🔥')">🔥</span>
              <span class="cursor-pointer" @click="insertField('😍')">😍</span>
              <span class="cursor-pointer" @click="insertField('😂')">😂</span>
              <span class="cursor-pointer" @click="insertField('🙌')">🙌</span>
              <span class="cursor-pointer" @click="insertField('🤗')">🤗</span>
              <span class="cursor-pointer" @click="insertField('😎')">😎</span>
              <span class="cursor-pointer" @click="insertField('🏠')">🏠</span>
              <span class="cursor-pointer" @click="insertField('🏆')">🏆</span>
            </div>
            <div class="text-m w-full text-left hidden md:block">
              <label class="flex items-center text-sm font-medium pt-4 text-gray-700">Insert Lead Fields</label>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.first)">first</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.nickname)">nickname</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.fullName)">full</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.phone)">phone</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.email)">email</span>
              <span v-if="lead.fullNameCoborrower" class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.fullNameCoborrower)">co-name</span>
              <span v-if="lead.phoneCoborrower" class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.phoneCoborrower)">co-phone</span>
              <span v-if="lead.emailCoborrower" class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(lead.emailCoborrower)">co-email</span>
            </div>
            <div class="text-m mt-2 pb-2 w-full text-left hidden md:block">
              <label class="flex items-center text-sm font-medium pt-4 text-gray-700">Insert User Fields</label>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_first_name)">first name</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_last_name)">last name</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_phone)">phone</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_email)">email</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_application_link)">app</span>
              <span class="tag-input__tag text-white text-sm bg-indigo-600 cursor-pointer" @click="insertField(userInfo.user_appointment_link)">apt</span>
            </div>
          </div>
          <div class="pb-4 w-full">
            <attachment-uploader :initial-attachment-url="smsForm.attachment" @update:attachmentUrl="updateAttachmentUrl" />
          </div>
          <div class="flex justify-center items-center mt-5">
            <div>
              <loading-button :loading="smsForm.processing" class="btn-indigo ml-auto" type="submit">Send Text</loading-button>
            </div>
          </div>
        </form>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import AttachmentUploader from '@/Shared/AttachmentUploader'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    TextareaInput,
    SelectInput,
    LoadingButton,
    AttachmentUploader,
  },
  props: {
    lead:{
      type: Object,
      default: null,
    },
    userInfo: {
      type: Object,
      default: null,
    },
    smsTemplates: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      smsForm: router.form({
        lead_id: this.lead.id,
        smsTemplate: '',
        textTo: [
          this.lead.phone,
        ],
        attachment: null,
      }),
      sendingToNumber: this.lead.phone,
      selectedInputId: '',
      attachmentError:'',
    }
  },
  computed: {
    smsName() {
      let firstName = this.lead.nickname ? this.lead.nickname : this.lead.fullName.trim().split(' ')[0]
      let firstNameCoborrower = this.lead.nicknameCoborrower ? this.lead.nicknameCoborrower : this.lead.fullNameCoborrower.trim().split(' ')[0]

      if (this.smsForm.textTo.includes(this.lead.phone) && !this.smsForm.textTo.includes(this.lead.phoneCoborrower)) {
        return firstName
      } else if (!this.smsForm.textTo.includes(this.lead.phone) && this.smsForm.textTo.includes(this.lead.phoneCoborrower)) {
        return firstNameCoborrower
      } else if (this.smsForm.textTo.includes(this.lead.phone) && this.smsForm.textTo.includes(this.lead.phoneCoborrower)) {
        return `${firstName} & ${firstNameCoborrower}`
      }
      return ''
    },
    smsTemplateOptions() {
      var smsTemplateOptions = this.smsTemplates
      return smsTemplateOptions
    },
  },
  watch: {
    'smsForm.textTo': 'onTemplateChange',
    selectedInputId: 'onTemplateChange',
  },
  methods:{
    onTemplateChange(){
      if (this.selectedInputId) {
        const selectedTemplate = this.smsTemplates.find(item => item.id === this.selectedInputId)

        if (selectedTemplate) {
          this.updateMessage(selectedTemplate.message)
          this.smsForm.attachment = selectedTemplate.attachment
        }
      }
    },
    insertField(token) {
      // Get the text area element
      let textArea = document.getElementById('smsTemplate')

      // Save the current cursor position
      let cursorPos = textArea.selectionStart

      // Insert the emoji at the cursor position
      textArea.value = textArea.value.substring(0, cursorPos) + token + textArea.value.substring(cursorPos)

      // Update the cursor position to be after the inserted emoji
      textArea.selectionEnd = cursorPos + token.length

      this.smsForm.smsTemplate = textArea.value

      textArea.focus()
    },
    borrowerTo() {
      this.sendingToNumber = this.lead.phone;
      this.onTemplateChange(); // Trigger template update
    },
    coBorrowerTo() {
      this.sendingToNumber = this.lead.phoneCoborrower;
      this.onTemplateChange(); // Trigger template update
    },
    bothTo() {
      this.sendingToNumber = this.lead.phone + ' & ' + this.lead.phoneCoborrower;
      this.onTemplateChange(); // Trigger template update
    },
    updateMessageWithTemplate() {
      if (this.selectedInputId) {
        const selectedTemplate = this.smsTemplates.find(item => item.id === this.selectedInputId)
        if (selectedTemplate) {
          this.updateMessage(selectedTemplate.message)
        }
      }
    },
    updateMessage(message) {
      // Update the message based on the selected radio button
      message = message.replace('%first%', this.smsName)
      Object.keys(this.lead).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.lead[key])
      })
      Object.keys(this.userInfo).forEach(key => {
        const regex = new RegExp('%' + key + '%', 'g')
        message = message.replace(regex, this.userInfo[key])
      })
      this.smsForm.smsTemplate = message.replace(/(<([^>]+)>)/gi, '')
    },
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    updateAttachmentUrl(url) {
      this.smsForm.attachment = url
    },
    sendSms() {
      const smsTemplateLower = this.smsForm.smsTemplate.toLowerCase()
      const loanErrorDiv = document.getElementById('loan_error')

      if (smsTemplateLower.includes('loan')) {
        loanErrorDiv.innerText = 'Remove the word "loan" from SMS message.'
        loanErrorDiv.classList.remove('hidden')
        return
      }

      if (smsTemplateLower.includes('credit repair')) {
        loanErrorDiv.innerText = 'Remove the word "credit repair" from SMS message.'
        loanErrorDiv.classList.remove('hidden')
        return
      }

      loanErrorDiv.classList.add('hidden')

      this.smsForm.post('/sms', {
        onSuccess: () => {
          this.smsForm.smsTemplate=''
          this.smsForm.attachment=''
          this.closeModal()
          console.log('SMS SENT')
        },
      })
    },
  },
}
</script>
